export const cold_wind_levels = {
    1: '1档',
    2: '2档',
    3: '3档',
    4: '4档',
    5: '5档',
    6: '6档',
    7: '7档',
    8: '8档',
    9: '9档',
}

export const hot_wind_levels = {
    1: '1档',
    2: '2档',
    3: '3档',
    4: '4档',
}

export const timing_levels = [
    {
        label:'关闭',
        value:0
    },
    {
        label:'0.5小时',
        value:30
    },{
        label:'1小时',
        value:60
    },{
        label:'1.5小时',
        value:90
    },{
        label:'2小时',
        value:120
    },{
        label:'2.5小时',
        value:150
    },{
        label:'3小时',
        value:180
    },{
        label:'3.5小时',
        value:210
    },{
        label:'4小时',
        value:240
    },{
        label:'4.5小时',
        value:270
    },{
        label:'5小时',
        value:300
    },{
        label:'5.5小时',
        value:330
    },{
        label:'6小时',
        value:360
    },{
        label:'6.5小时',
        value:390
    },{
        label:'7小时',
        value:420
    },{
        label:'7.5小时',
        value:450
    },{
        label:'8小时',
        value:480
    }
]
